






















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Components
import { FormImportAssistance } from '@/components/assistance'

@Component({
    name: 'ModalImportAssistance',
    components: {
        FormImportAssistance
    }
})
export default class ModalImportAssistance extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, required: true, default: 'device' }) typeImport!: string

    title = 'Importar Asistencia'
}
